import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";
import { ActionListSkeleton } from "./action-list-skeleton";

/**
 * A document's review page while the document loads: the header, the
 * document and the actions column where they will be, so the page doesn't
 * jump from a line of text to the full layout.
 */
export const DocumentReviewSkeleton = () => (
  <Stack className="w-full" align="start" gap={4}>
    <Stack className="w-full" align="start" gap={1}>
      <Stack direction="row" gap={2} align="center">
        <Skeleton className="h-7 w-56" />
        <Skeleton className="h-5 w-20 rounded-full" />
      </Stack>
      <Skeleton className="h-4 w-72" />
    </Stack>
    <Stack
      align="start"
      gap={0}
      className="grid w-full grid-cols-1 gap-6 lg:grid-cols-[minmax(0,1fr)_480px]"
    >
      <Skeleton className="h-[60vh] w-full rounded-lg sm:h-[78vh]" />
      <Stack className="w-full" align="start" gap={4}>
        <Skeleton className="h-5 w-32" />
        <ActionListSkeleton />
      </Stack>
    </Stack>
  </Stack>
);
